/*
  Wearo mobile sticky add-to-cart bar behaviour.

  Extracted verbatim from the inline <script> in snippets/buy-buttons.liquid.

  Note: this wraps Dawn own add-to-cart button rather than replacing it, so the
  sticky bar mirrors whatever state the real form is in. Do not reorder the
  buy_buttons block away from the product form or the lookups here fail soft
  (they console.log and bail).
*/


(function() {

  function initStickyPDP() {

    /*
     * FIND STICKY BAR
     */

    const stickyBar =
      document.getElementById('sticky-pdp-cta');

    if (!stickyBar) {

      console.log('Sticky PDP: bar not found');

      return;

    }


    /*
     * MOVE STICKY BAR TO BODY
     *
     * This is important because some
     * Shopify sections have overflow/transform
     * which can break position:fixed.
     */

    if (stickyBar.parentElement !== document.body) {

      document.body.appendChild(stickyBar);

    }


    /*
     * FIND PRODUCT FORM
     */

    const productForm =
      document.querySelector(
        'form[data-type="add-to-cart-form"]'
      );


    if (!productForm) {

      console.log('Sticky PDP: product form not found');

      return;

    }


    /*
     * ORIGINAL ADD TO CART
     */

    const originalAddToCart =
      productForm.querySelector(
        'button[name="add"]'
      );


    if (!originalAddToCart) {

      console.log('Sticky PDP: original ATC not found');

      return;

    }


    /*
     * STICKY BUTTONS
     */

    const stickyAddToCart =
      document.getElementById(
        'sticky-add-to-cart'
      );

    const stickyBuyNow =
      document.getElementById(
        'sticky-buy-now'
      );

    const stickyCartText =
      document.getElementById(
        'sticky-cart-text'
      );

    const stickyCartLoading =
      document.getElementById(
        'sticky-cart-loading'
      );


    /*
     * SHOW / HIDE STICKY BAR
     */

    function updateStickyVisibility() {

      const rect =
        originalAddToCart.getBoundingClientRect();


      /*
       * Original ATC visible
       */

      if (
        rect.top < window.innerHeight &&
        rect.bottom > 0
      ) {

        stickyBar.classList.remove(
          'sticky-visible'
        );

      }

      /*
       * Original ATC NOT visible
       */

      else {

        stickyBar.classList.add(
          'sticky-visible'
        );

      }

    }


    /*
     * SCROLL
     */

    window.addEventListener(
      'scroll',
      updateStickyVisibility,
      { passive: true }
    );


    /*
     * INITIAL
     */

    updateStickyVisibility();


    /*
     * UPDATE BUTTON STATE
     */

    function updateButtonState() {

      const disabled =
        originalAddToCart.disabled;


      stickyAddToCart.disabled =
        disabled;

      stickyBuyNow.disabled =
        disabled;


      if (disabled) {

        stickyCartText.textContent =
          'Sold Out';

      }

      else {

        stickyCartText.textContent =
          'Add to Cart';

      }

    }


    /*
     * INITIAL STATE
     */

    updateButtonState();


    /*
     * WATCH VARIANT / DISABLED
     */

    const buttonObserver =
      new MutationObserver(
        function() {

          updateButtonState();

        }
      );


    buttonObserver.observe(
      originalAddToCart,
      {
        attributes: true,
        attributeFilter: ['disabled']
      }
    );


    /*
     * VARIANT CHANGE
     */

    productForm.addEventListener(
      'change',
      function() {

        setTimeout(
          updateButtonState,
          100
        );

      }
    );


    /*
     * ==========================================
     * STICKY ADD TO CART
     * ==========================================
     */

    stickyAddToCart.addEventListener(
      'click',
      function() {

        if (
          originalAddToCart.disabled
        ) {

          return;

        }


        /*
         * Prevent double click
         */

        stickyAddToCart.disabled =
          true;


        stickyCartText.style.display =
          'none';

        stickyCartLoading.style.display =
          'inline';


        /*
         * Trigger Shopify's
         * ORIGINAL ATC
         */

        originalAddToCart.click();


        /*
         * Reset after 1.5 sec
         */

        setTimeout(
          function() {

            stickyCartText.style.display =
              'inline';

            stickyCartLoading.style.display =
              'none';

            updateButtonState();

          },
          1500
        );

      }
    );


    /*
     * ==========================================
     * BUY NOW
     * ==========================================
     */

    stickyBuyNow.addEventListener(
      'click',
      function() {

        if (
          originalAddToCart.disabled
        ) {

          return;

        }


        /*
         * CURRENT VARIANT
         */

        const variantInput =
          productForm.querySelector(
            'input[name="id"]'
          );


        if (
          !variantInput ||
          !variantInput.value
        ) {

          return;

        }


        /*
         * QUANTITY
         */

        const quantityInput =
          productForm.querySelector(
            'input[name="quantity"]'
          );


        const quantity =
          quantityInput
            ? quantityInput.value
            : '1';


        /*
         * CREATE CHECKOUT FORM
         */

        const checkoutForm =
          document.createElement('form');


        checkoutForm.method =
          'POST';


        checkoutForm.action =
          '/cart/add';


        checkoutForm.style.display =
          'none';


        /*
         * VARIANT ID
         */

        const variant =
          document.createElement('input');

        variant.type =
          'hidden';

        variant.name =
          'id';

        variant.value =
          variantInput.value;


        /*
         * QUANTITY
         */

        const qty =
          document.createElement('input');

        qty.type =
          'hidden';

        qty.name =
          'quantity';

        qty.value =
          quantity;


        /*
         * REDIRECT TO CHECKOUT
         */

        const returnTo =
          document.createElement('input');

        returnTo.type =
          'hidden';

        returnTo.name =
          'return_to';

        returnTo.value =
          '/checkout';


        /*
         * ADD TO FORM
         */

        checkoutForm.appendChild(
          variant
        );

        checkoutForm.appendChild(
          qty
        );

        checkoutForm.appendChild(
          returnTo
        );


        /*
         * SUBMIT
         */

        document.body.appendChild(
          checkoutForm
        );


        checkoutForm.submit();

      }
    );

  }


  /*
   * INITIALIZE
   */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initStickyPDP
    );

  }

  else {

    initStickyPDP();

  }

})();



/*
  ---------------------------------------------------------------------------
  Sticky bar detail row — keeps the size and price in sync with the variant.

  Deliberately a separate IIFE from the block above, which was lifted verbatim
  from the old inline script. Keeping them apart means this can be reasoned
  about (and reverted) without disturbing the add-to-cart wiring.

  The price is MIRRORED from Dawn's own price block rather than recalculated.
  Dawn already re-renders that block on variant change, and discount apps hook
  it too, so mirroring is the only way the two prices cannot disagree.
  ---------------------------------------------------------------------------
*/
(function () {
  function init() {
    var variantEl = document.getElementById('sticky-pdp-variant');
    var priceEl = document.getElementById('sticky-pdp-price');
    var info = document.querySelector('.product__info-container');

    if (!info || (!variantEl && !priceEl)) return;

    // The real price block. Dawn gives it id="price-{section.id}" and no class.
    var sourcePrice = info.querySelector('[id^="price-"]');

    function selectedVariantLabel() {
      // Keyed by the input's `name`, which is the option group. Dawn replaces
      // the picker's markup on variant change, and a read landing mid-swap can
      // see the old AND new picker at once — that produced a sticky bar
      // reading "30 / 30" for a single-option product. One value per group
      // makes a transient duplicate harmless.
      var byGroup = new Map();

      // Button-style picker (this store uses picker_type: "button").
      info
        .querySelectorAll('.product-form__input input[type="radio"]:checked')
        .forEach(function (input) {
          var group = (input.name || '').trim();
          var value = (input.value || '').trim();
          if (value && !byGroup.has(group)) byGroup.set(group, value);
        });

      // Dropdown-style picker, in case the picker type is ever switched.
      if (!byGroup.size) {
        info.querySelectorAll('.product-form__input select').forEach(function (sel) {
          var group = (sel.name || '').trim();
          var value = (sel.value || '').trim();
          if (value && !byGroup.has(group)) byGroup.set(group, value);
        });
      }

      return [...byGroup.values()].join(' / ');
    }

    function sync() {
      if (variantEl) {
        var label = selectedVariantLabel();
        variantEl.textContent = label;
        variantEl.hidden = !label;
      }

      if (priceEl && sourcePrice) {
        priceEl.innerHTML = sourcePrice.innerHTML;
      }
    }

    sync();

    // Variant changes come through the form; Dawn swaps the price block a beat
    // later, so read after it settles. Matches the 100ms the block above uses.
    var form = info.querySelector('form[action*="/cart/add"]') || info;
    form.addEventListener('change', function () {
      setTimeout(sync, 120);
    });

    // Belt and braces: if anything else rewrites the price block (a discount
    // app, a cart-level promo), mirror that too.
    if (sourcePrice) {
      new MutationObserver(sync).observe(sourcePrice, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
